// extracted by mini-css-extract-plugin
export default {"actionButton":"Dialog_actionButton__7Mj6x","dialogTitle":"Dialog_dialogTitle__2YqgC","dialogContent":"Dialog_dialogContent__6Anrc","table":"Dialog_table__3KPAQ"};